import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    dashboard: 'Dashboard',
    delegateStaking: 'Delegate Staking',
    defi: 'DeFi',
    poolOwnerPanel: 'Pool Owner Panel',
    staking: 'Liquid Staking',
  },
};
